import styled from 'styled-components'
import { media } from 'styled-bootstrap-grid'

export const Title = styled.h1`
  font-size: 30px;
  font-weight: 600;
  color: #152735;
  text-align: center;
  padding: 0 1rem;
  margin-bottom: 1.5rem;
`

export const Description = styled.p`
  font-size: 1rem;
  color: #585d64;
  text-align: center;
  padding: 0 1rem;
  margin-bottom: 3rem;
  font-weight: bold;
`

export const WelcomeWrap = styled.div`
  ${media.xs`
    width: 100%;
  `}
  ${media.sm`
    width: 100%;
  `}
  ${media.md`
    width: 380px;
  `}
`

export const Buttons = styled.div`
  display: flex;
  flex-direction: column;

  a,
  button {
    margin-bottom: 20px;
  }
`
export const TipList = styled.ul`
  margin: 0 auto 3rem;
  width: 65%;

  ${media.xs`
    width: 90%;
  `}
  ${media.sm`
     width: 65%;
  `}

  li {
    list-style: none;
    color: #585d64;
    margin-bottom: 12px;
    max-height: 30px
  }

  svg {
    width: 1rem;
    margin-right: 0.5rem;
    fill: #585d64;
    max-height: 25px
  }
`
